import createDomainSelectors from 'store/createDomainSelectors'
import { initialState } from 'modules/Services/CampaignsEditor/store/reducer'

const { selectSlice, selectField } = createDomainSelectors(
  'services/campaigns-editor',
  initialState,
)

// export const selectCampaignsEditor = selectSlice
export const selectCELoading = selectField('loading')
export const selectCEFilters = selectField('filters')
export const selectCECurrentResource = selectField('currentResource')
export const selectCECounters = selectField('counters')
export const selectCEGroupProcessing = selectField('groupProcessing')

export const selectCEResource = (resource) => (state) =>
  selectSlice(state)?.[resource]

export const selectCEResourceField = (resource, field) => (state) =>
  selectSlice(state)?.[resource]?.[field]

export const selectCESelectionIds = (resource) => (state) =>
  selectSlice(state)?.[resource]?.selection?.ids || {}

export const selectCEAllSelections = (state) => {
  const slice = selectSlice(state)
  return {
    campaigns: slice.campaigns?.selection?.ids || {},
    'ad-groups': slice['ad-groups']?.selection?.ids || {},
    banners: slice.banners?.selection?.ids || {},
  }
}
